export default __webpack_public_path__ + "static/media/Goopter-logo.417ab5dd.svg";